import { Domain } from "./Domain";

export interface DomainEditConstructor extends Domain {}

export class DomainEdit implements Omit<Domain, "id"> {
  public readonly name: string;
  public readonly domain_url: string;

  constructor(contructor: DomainEditConstructor) {
    this.name = contructor.name;
    this.domain_url = contructor.domain_url;
  }
}
